import { NgModule } from '@angular/core';
import { MaterialModule } from './material/material.module';

/**
 * Re-export barrel for Angular Material used by shared UI.
 * Keeps Material imports out of heavy feature-only packages.
 */
@NgModule({
  imports: [MaterialModule],
  exports: [MaterialModule],
})
export class SharedMaterialModule {}
